import React from 'react'
import { 
  CtaButton, 
  Tooltip, 
  CheckIcon, 
  CircleInfoIcon, 
  LockIcon 
} from '@repo/ui'
import type { CheckInStatus } from '../types/domain'

export const createCheckInItemCta = (status: CheckInStatus, t: (key: string) => string): React.ReactNode => {
  const labelMap: Record<CheckInStatus, string | undefined> = {
    used: t('Used'),
    unused: t('Claim'),
    auto: t('Unused'),
    expired: t('Expired'),
    locked: undefined,
  }

  const tooltipFor = (status: CheckInStatus) => {
    if (status === 'unused') return t('Add reward to your inventory')
    if (status === 'auto') return t('Boost will automatically be applied on your next bet')
    if (status === 'locked') return t('Locked')
    return undefined
  }

  const iconFor = (status: CheckInStatus) => {
    switch (status) {
      case 'used':
        return <CheckIcon className="w-[14px] drop-shadow-soft-black" />
      case 'locked':
        return <LockIcon className="w-[14px] opacity-60 drop-shadow-soft-black" />
      case 'auto':
        return <CircleInfoIcon className="w-[14px]" />
      case 'unused':
        return <CircleInfoIcon className="w-[14px]" />
      default:
        return null
    }
  }

  const actionable = status === 'unused'
  const tone: 'active' | 'inactive' = status === 'unused' || status === 'auto' ? 'active' : 'inactive'
  const button = (
    <CtaButton
      disabled={!actionable}
      icon={iconFor(status)}
      label={labelMap[status]}
      status={tone}
    />
  )


  switch (status) {
    case 'unused':
      return (
        <Tooltip position="top" trigger={button}>
          <div className="max-w-[140px] sm:max-w-[180px]">{tooltipFor('unused')}</div>
        </Tooltip>
      )
    case 'auto':
      return (
        <Tooltip position="top" trigger={button}>
          <div className="max-w-[140px] sm:max-w-[180px]">{tooltipFor('auto')}</div>
        </Tooltip>
      )
    case 'locked':
      return (
        <Tooltip position="top" trigger={button}>
          <div className="max-w-[140px] sm:max-w-[180px]">{tooltipFor('locked')}</div>
        </Tooltip>
      )
    default:
      return button
  }
}
